export const uk = {
    'add-creatives': 'Добавить выбранные',
    apply: 'Использовать',
    'cancel-and-return': 'Отмена',
    create: 'Создать на основе',
    edit: 'Изменить',
    'export-excel': 'Экспортировать список в XLS',
    select: 'Выбрать',
    selected: 'Выбрано {selected} из {total}'
};
